import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="weather app" link="https://ibibo-weather-application.herokuapp.com/" bg="linear-gradient(to right, #2b5876 0%, #4e4376 100%)" mdxType="ProjectCard">
  built with node.js and express.js.
    </ProjectCard>
    <ProjectCard title="coin chart" link="https://cryprochat-ib.netlify.app/" bg="linear-gradient(to right, #2b5876 0%, #4e4376 100%)" mdxType="ProjectCard">
  built with react.js
    </ProjectCard>
    <ProjectCard title="my recipie diary" link="https://play.google.com/store/apps/details?id=com.hng.howtodo" bg="linear-gradient(to right, #2b5876 0%, #4e4376 100%)" mdxType="ProjectCard">
  built with flutter
    </ProjectCard>
    <ProjectCard title="my store" link="https://github.com/ibdaye/my_store" bg="linear-gradient(to right, #2b5876 0%, #4e4376 100%)" mdxType="ProjectCard">
  built with node.js, express.js and mongoDB
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      